import {
  loginError,
  loginRequest,
  loginSuccess,
  logoutSuccess,
} from "./reducer";
import { ThunkAction } from "redux-thunk";
import { Action, Dispatch } from "redux";
import { RootState } from "slices";
import { loginUser as loginUserApi } from "helpers/backend_helper";
import { toast } from "react-toastify";
import { setAuthorization } from "helpers/api_helper";
import { loadRoleConfig } from "slices/thunk";

interface User {
  email: string;
  password: string;
}

export const loginUser =
  (
    user: User,
    history: any
  ): ThunkAction<void, RootState, unknown, Action<string>> =>
  async (dispatch: Dispatch<any>) => {
    dispatch(loginRequest());
    try {
      const response: any = await loginUserApi(user);
      const userRole = response?.result?.userInfo?.role;
      if (response && response.result.success) {
        localStorage.setItem("authToken", response.result.authToken);
        setAuthorization(response?.result?.authToken);
        dispatch(loginSuccess(response?.result));
        dispatch(loadRoleConfig(response?.result?.userInfo?.role, history));
        localStorage.setItem("userRole", response?.result?.userInfo?.role);
        if (userRole === "superAdmin") {
          history("/jewellery-orders");
        } else if (userRole === "productsLister") {
          history("/jewellery");
        }
        toast.success("login successfully!");
      }
    } catch (error) {
      dispatch(loginError(error));
    }
  };

export const logoutUser = () => async (dispatch: Dispatch) => {
  try {
    localStorage.removeItem("authUser");
    localStorage.removeItem("authToken");
    localStorage.removeItem("userRole");
    localStorage.removeItem("extensions");

    dispatch(logoutSuccess(true));
  } catch (error) {
    dispatch(loginError(error));
  }
};

// export const socialLogin =
//   (type: any, history: any) => async (dispatch: any) => {
//     try {
//       const response: any = await loginUserApi({ socialType: type });

//       if (response && response.result.success) {
//         sessionStorage.setItem("authUser", JSON.stringify(response.result.user));
//         dispatch(loginSuccess(response?.result?.user));
//         history("/dashboard");
//       }
//     } catch (error) {
//       dispatch(loginError(error));
//     }
//   };
